import { PLAN_MANAGEMENT_V2 } from '../../../../paths'

export const PLAN_SMOKER_RATE_OVERRIDES = `/${PLAN_MANAGEMENT_V2}/overrides/smoker-rates`

export const planSmokerRateOverridesPath = (subtab?: string) =>
  subtab
    ? `${PLAN_SMOKER_RATE_OVERRIDES}/${subtab.toLowerCase()}`
    : `${PLAN_SMOKER_RATE_OVERRIDES}/inactive`
